/* Bridge between the flat string lists we store and react-select's option
 * objects.
 *
 * Several admin forms keep plain strings in the component JSON — GroupedItems'
 * findCategory is `PropTypes.arrayOf(PropTypes.string)` on the front's
 * Launcher2 — while react-select v5 requires every option to be an object: it
 * detects option groups with `'options' in option`, which throws a TypeError
 * on a primitive and takes the page down. So convert at the select boundary
 * and leave the stored shape alone.
 *
 * Sibling, different job: selectHandlers' transformDataToSelectOptions turns a
 * single scalar into a single option, for single-select `value` props. These
 * two are the isMulti pair — a list in, a list out. */

const optionFromValue = (entry) => {
  if (entry && typeof entry === 'object') {
    const value = entry.value !== undefined ? entry.value : entry.label;
    const label = entry.label !== undefined ? entry.label : value;
    return { label: String(label), value: String(value) };
  }
  return { label: String(entry), value: String(entry) };
};

const isEmpty = entry => entry === null || entry === undefined || entry === '';

// Stored strings (or already-shaped options) -> options react-select can read.
const toSelectOptions = (values) => {
  if (!Array.isArray(values)) return [];
  return values.filter(entry => !isEmpty(entry)).map(optionFromValue);
};

// What react-select hands back -> the flat strings we store. isMulti gives
// null once the last chip is cleared, hence the array guard.
const fromSelectOptions = (options) => {
  if (!Array.isArray(options)) return [];
  return options
    .map((entry) => {
      if (entry && typeof entry === 'object') {
        return entry.value !== undefined ? entry.value : entry.label;
      }
      return entry;
    })
    .filter(entry => !isEmpty(entry))
    .map(String);
};

module.exports = { toSelectOptions, fromSelectOptions };
